module.exports = __webpack_public_path__ + "components/flag/static/square/mc-5bdaebb98f4544277dfdd295a0370126.svg";